import { render, staticRenderFns } from "./CourseSignUpIntro.vue?vue&type=template&id=2461b1d3&scoped=true"
import script from "./CourseSignUpIntro.vue?vue&type=script&lang=ts"
export * from "./CourseSignUpIntro.vue?vue&type=script&lang=ts"
import style0 from "./CourseSignUpIntro.vue?vue&type=style&index=0&id=2461b1d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461b1d3",
  null
  
)

export default component.exports